module.exports = __webpack_public_path__ + "static/media/system.253e37e1.svg";